var utilities = {

    init: function () {
        this.radioSelectLabel();
        this.scrollToElement();
        this.closeElements();
        this.slideToggle();
        this.videoShare();
        this.initFancyBox();
        this.initOutphased();
    },
    initOutphased: function()
    {
        $("#onOutphased").click(function () {
            document.getElementsByClassName('outphased-panel')[0].style.display = '';
            document.getElementsByClassName('outphasing-panel')[0].style.display = 'none';
            $("#onOutphasing").removeClass("active");
            $(this).addClass("active");
            var text = $(this).text();
            $(".outphased-product-headline").text(text);
        });
        $("#onOutphasing").click(function () {
            document.getElementsByClassName('outphased-panel')[0].style.display = 'none';
            document.getElementsByClassName('outphasing-panel')[0].style.display = '';
            $("#onOutphased").removeClass("active");

            $(this).addClass("active");
            var text = $(this).text();
            $(".outphased-product-headline").text(text);
        });
    },
    videoShare: function () {

        var isMobile = false;
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;

        if ($('.video-share').length) {

            $('.video-share').each(function () {
                if (isMobile == true) {
                    $(this).addClass('touch-device');
                }
            });

            $('.video-share__icon').click(function () {
                var $current = $(this).closest('.video-share');
                $current.toggleClass('active');
            });
        }
    },

    slideToggle: function () {
        if ($('.download-center').length || $('.marketing').length) {
            $('.download-category__category span').click(function () {
                var category = $(this).closest('.download-category');
                $('.download-category__category', category).toggleClass('active');
                $('.downloads', category).slideToggle();
            });
        }
    },

    radioSelectLabel: function () {
        if ($('.radio-select').length) {
            $('.radio-select').each(function () {
                var $current = $(this);
                var $label = $('.radio-select__trigger', $current);
                var initListName = $('.radio-select__radio:checked', $current).closest('.radio-select__item').find('.radio-select__query').text();
                if (initListName !== "") {
                    $label.text(initListName);
                }
                else if ($label == "") {
                    $label.text(String.fromCharCode(160));
                }
                else {
                    
                }
            });

            $('.radio-select__label').click(function () {
                var $current = $(this).closest('.radio-select');

                //KT trying to fix mobile selector
                $current.find('.radio-select__list input').removeAttr("checked");
                var $input = $(this).parent().find('input');
                $input.attr("checked", "checked");

                var $label = $('.radio-select__trigger', $current);
                var initListName = $('.radio-select__query', this).text();
                $label.text(initListName);
            });
        }
    },

    closeElements: function () {
        $('body').on('click', '.checkbox-select__trigger', function (e) {
            var current = $(this).closest('.checkbox-select');
            var checkbox = $(current).find('.checkbox-select__checkbox').first();

            $('.checkbox-select > .checkbox-select__checkbox').not(checkbox).prop('checked', false);
            $('.radio-select > .radio-select__checkbox').prop('checked', false);
        });

        $('body').on('click', '.radio-select__trigger', function (e) {
            var current = $(this).closest('.radio-select');
            var checkbox = $(current).find('.radio-select__checkbox').first();

            $('.radio-select > .radio-select__checkbox').not(checkbox).prop('checked', false);
            $('.checkbox-select > .checkbox-select__checkbox').prop('checked', false);
        });
     
        $(document).on('click', function (e) {
            if ($('.checkbox-select').length || $('.radio-select').length) {
                var current = e.target;
                var currentClass = $(current).prop('class');
                if (currentClass.indexOf('checkbox-select') >= 0 || currentClass.indexOf('radio-select') >= 0) {
                } else {
                    $('.checkbox-select > .checkbox-select__checkbox').prop('checked', false);
                    $('.radio-select > .radio-select__checkbox').prop('checked', false);
                }    
            }
        });        
    },

    scrollToElement: function () {
        if ($('.scroll-to-trigger').length) {
            $('.scroll-to-trigger').click(function () {
                var target = $(this).data('scroll-target');
                $('html, body').animate({
                    scrollTop: $(target).offset().top
                }, 500);
            });
        }
    },   

    detectOrientation: function () {
        var isMobile = false;
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;

        if (isMobile == true) {            
            utilities.checkMobileSize();
            $(window).on("resize", utilities.checkMobileSize);
        }
    },

    checkMobileSize: function(){
        var width = window.innerWidth;
        var height = window.innerHeight;

        if (height >= 897 || width >= 897) {
            if (height > width) {
                $('#orientation-alert').addClass('orientation-alert--active');
            }
            else {
                $('#orientation-alert').removeClass('orientation-alert--active');
            }
        }
    },
    initFancyBox: function(){
        $(".fancyboxIframe").fancybox({
            maxWidth: 900,
            maxHeight: 675,
            fitToView: true,
            width: '90%',
            height: '90%',
            autoSize: false,
            closeClick: false,
            openEffect: 'none',
            closeEffect: 'none',
            overlayColor: '#000',
            iframe: {
                scrolling: 'auto',
                preload: true
            }
        });
    }
}

function getParameterByName(name, url) {
        if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
}




$(document).ready(function () {
    utilities.init();
    utilities.detectOrientation();
});
